<template>
    <div v-if="error" class="error">{{errorMsg}}</div>
</template>

<script>
    export default {
        name: 'OSJErrorMsg',
        props: {
            error: Boolean,
            errorMsg: String
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    .error {
        display: block;
        margin-bottom: 1rem;
        background-color: $red;
        padding: 0.4rem 1rem;
        font-weight: 700;
        color: white;
        border-radius: $radius;
    }
</style>